<template>
  <div v-if="survey" id="scrollparent" ref="scrollparent">
    <!-- breadcrumbs -->
    <v-divider></v-divider>
      <!-- <v-layout ma-0 py-1 class="d-flex align-center justify-space-between">
        <span class="d-flex align-center justify-space-between">
          {{currentQuest.info[`title_${$i18n.locale}`]}}
        </span>
      </v-layout>
    <v-divider></v-divider> -->
    <!-- breadcrumbs -->

    <v-row wrap class="mt-5 mt-md-8">
      <!-- Navigate between sequences -->
      <v-col cols="12" md="5" order-md="2" v-scroll="onScroll" ref="sticky" class="sticky-nav">

        <SubmitAudit
          :answerid="$route.params.answerid"
          :survey="survey"
          :firm="firm"
          class="mb-5"></SubmitAudit>

      </v-col>

      <v-col cols="12" md="7" ref="ancre">
          <template v-if="renderComponent && currentQuest">
            <UQuestionBox v-if="currentQuest"
                          :answerid="$route.params.answerid"
                          :questionid="$route.params.questionid"
                          :question="currentQuest"
                          :maxDerogations="parseInt(survey.total.maxderogations)"
                          :doneDerogations="parseInt(survey.done.maxderogations)"
                          @changeQuest="nextPrevQuest"
                          @updateSubmitBtn="refreshSubmitBtn"
            ></UQuestionBox>
          </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { showUQuestion } from '@/js/survey/showUQuestion'
import UQuestionBox from '@/components/audits/survey/UQuestionBox'
import SubmitAudit from '@/components/audits/SubmitAudit'

export default {
  props: {
    survey: Array | Object,
    firm: Array | Object,
    // createdBreadcrumbs: Array | Object,
    // createdTab: Array | Object
  },

  components: {
    UQuestionBox,
    SubmitAudit
  },

  data () {
    return {
      // breadcrumbs: this.createdBreadcrumbs ? this.createdBreadcrumbs : { sequence: null, question: null },
      // tab: this.createdTab ? this.createdTab : { type: 'sequence', object: null },
      currentQuest: null,
      renderComponent: true
    }
  },

  async created () {
    // if (this.$route.params.tab) {
    //   this.breadcrumbs.question = this.$route.params.tab
    //   this.breadcrumbs.sequence = this.createdBreadcrumbs.sequence
    // }

    await this.survey.unanswered_mandatory.forEach(async quest => {
      // await this.loadQuestion(quest);
      if (this.$route.params.questionid == quest.id) await this.loadQuestion(quest);
    });
  },

  methods: {
    async loadQuestion (quest) {
      const params = {
        questionid: quest.id,
        answerid: this.$route.params.answerid,
        key: this.$store.state.auth.token
      }
      await showUQuestion(params)
        .then(response => {
          this.currentQuest = response
        })
    },

    nextPrevQuest (questid) {
      this.$router.replace({ name: 'edit-audit-unanswered', params: { questionid: questid } });
      this.changeTab()
    },

    changeTab () {
      this.$emit('reloadSeq')
      this.forceRerender()
      this.$vuetify.goTo('#scrollparent')
    },
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false
      
      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true
        // this.$vuetify.goTo('scrollparent')
      })
    },

    onScroll () {
      if (this.$vuetify.breakpoint.name === 'xs' ||
          this.$vuetify.breakpoint.name === 'sm') {

        this.$refs.sticky.style.transform = 'translateY(0px)'
        return
      }
      // this.offsetTop = e.target.scrollTop
      const sticky = this.$refs.sticky
      const offsetTop = window.pageYOffset || document.documentElement.scrollTop

      if (offsetTop > sticky.offsetTop) {
        // console.log(this.$refs.scrollparent.offsetTop)
        if (((offsetTop - sticky.offsetTop - 100) + sticky.offsetHeight) >= (this.$refs.scrollparent.offsetHeight - 100)) return
        // (offsetTop - sticky.offsetTop - 100) + 
        sticky.style.transform = `translateY(${offsetTop - sticky.offsetTop - 100}px)`
      }
      else {
        sticky.style.transform = 'translateY(0px)'
      }
    },

    refreshSubmitBtn () {
      this.$emit('reloadSubmitBtn')
    },
  }
}
</script>
